/* RESPONSIBLE TEAM: team-standalone */

import { IntegrationState, StandalonePlatform } from '../constants';
import Platform from './platform';
import type ApplicationInstance from '@ember/application/instance';
import HubspotConversationExtractionRow from './component-data/hubspot/conversation-extraction-row';
import HubspotConversationExcerpt from './component-data/hubspot/conversation-excerpt';
import GenericOnboardingGuideStep from './component-data/generic/onboarding-guide-step';
import GenericRequestAccessData from './component-data/generic/request-access';

export default class HubspotPlatform extends Platform {
  constructor(owner: ApplicationInstance) {
    super(owner);
  }

  get componentData(): Platform['componentData'] {
    return {
      'conversation-extraction': HubspotConversationExtractionRow,
      'conversation-excerpt': new HubspotConversationExcerpt(this),
      'knowledge-hub-modal': null,
      'onboarding-guide-step': new GenericOnboardingGuideStep(this),
      'request-access': new GenericRequestAccessData(this),
    } as const;
  }

  async loadConfigData() {
    // TODO
  }

  async loadRequiredData() {
    // TODO
  }

  async loadDataFields() {
    // TODO
  }

  get isConnected() {
    return false;
  }

  get hasInstalledCopilot() {
    return false;
  }

  get historicalSyncingEnabled() {
    return false;
  }

  get finIsLive() {
    return false;
  }

  get finIsPaused() {
    return false;
  }

  get showAnalyzeSectionConnectCta() {
    return false;
  }

  get connectionState() {
    return IntegrationState.NotConfigured;
  }

  get icon() {
    return 'hubspot' as const;
  }

  get platformKey() {
    return StandalonePlatform.Hubspot;
  }

  get supportsFinPlayground() {
    return false;
  }

  get supportsConversationSyncing() {
    return false;
  }

  findMappedConversationField(_id: string | undefined) {
    return undefined;
  }

  isMappedUserAttribute(_attributeIdentifier: string) {
    return false;
  }

  isMappedCompanyAttribute(_attributeIdentifier: string) {
    return false;
  }

  isMappedConversationAttribute(_attributeIdentifier: string) {
    return false;
  }

  get ticketFields() {
    return [];
  }

  get userFields() {
    return [];
  }

  get organizationFields() {
    return [];
  }
}
